import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ModalConfirmDescartPaperNoActionService } from './modal-confirm-descart-paper-no-action.service';
import { SignStatusEnum } from '../../enum/signStatusEnum';


@Component({
  selector: 'app-modal-confirm-descart-paper-no-action',
  templateUrl: './modal-confirm-descart-paper-no-action.component.html',
  styleUrls: ['./modal-confirm-descart-paper-no-action.component.scss']
})
export class ModalConfirmDescartPaperNoActionComponent implements OnInit {
  public showConfirm = false;

  private idPaper: number[];

  private signStatus: SignStatusEnum;

  constructor(
    private modalService: ModalConfirmDescartPaperNoActionService,
  ) { }

  ngOnInit(): void {
    this.modalService.getObservable().subscribe((pData) => {
      this.showConfirm = true;
      this.idPaper = pData.idPaper;
      this.signStatus = pData.signatureStatus;
    });
  }

  public close(): void {
    this.showConfirm = false;
    this.modalService.onCloseEvent.next({ evento: 'CANCELAR', dados: null });
  }

  public async delete(): Promise<void> {
    this.showConfirm = false;
    this.modalService.onCloseEvent.next({ evento: 'CONFIRMAR', dados: { idPaper: this.idPaper, signatureStatus: this.signStatus } });
  }
}
